import React from "react";
import Modal from "src/components/common/Modal";
import VideoPlayer from "../../video-player";

interface VideoPlayerModalProps {
  show: boolean;
  title: string;
  handleClose: () => void;
  videoUrl: string;
  type: "youtube" | "normal";
}

const VideoPlayerModal: React.FC<VideoPlayerModalProps> = ({
  show,
  title = "Video Player",
  handleClose,
  videoUrl,
  type,
}) => {
  if (!show) return null;
  return (
    <Modal
      show={show}
      title={title}
      handleClose={handleClose}
      showCloseButton={true}
    >
      <VideoPlayer videoUrl={videoUrl} type={type} />
    </Modal>
  );
};

export default VideoPlayerModal;
